import { render, staticRenderFns } from "./ChatDock.vue?vue&type=template&id=1dc83525&scoped=true"
import script from "./ChatDock.vue?vue&type=script&lang=js"
export * from "./ChatDock.vue?vue&type=script&lang=js"
import style0 from "./ChatDock.vue?vue&type=style&index=0&id=1dc83525&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc83525",
  null
  
)

export default component.exports